import React, { useContext } from "react";
import Skeleton from "./Skeleton";
import DataContext from "../../context/DataContext";

const VisitedListSkeleton = () => {
  const { centerWidth } = useContext(DataContext);
  const columCount = centerWidth < 845 ? "47%" : "23%";
  return (
    <div style={{ flex: `1 0 ${columCount}` }}>
      <Skeleton classes={"flex h-16 m-3 rounded-lg"} />
    </div>
  );
};

export default VisitedListSkeleton;
